import React, { useState } from 'react'
import { useActions, useValues } from 'kea'
import filtersLogic from '~/scenes/search/filters-page/logic'

import I18n from 'lib/i18n'
import Checkbox from 'lib/forms/checkbox-svg'
import Arrow from 'lib/icons/arrow'
import sceneLogic from '~/scenes/search/logic'

export default function TeacherSpeak () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { results } = useValues(sceneLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  const [expanded, setExpanded] = useState(false)

  // all possible tags
  const languages = results.most_popular_languages_in_country

  if (languages && languages.length === 0) {
    return null
  }

  const selectedLanguages = {}
  if ((unsavedFilter.teacher_languages || []).length !== 0) {
    unsavedFilter.teacher_languages.split(',').forEach(id => {
      selectedLanguages[parseInt(id).toString()] = true
    })
  }

  function toggleTag (id) {
    // get array with tag added or removed
    let languageIDs = Object.keys(selectedLanguages)
    if (languageIDs.includes(parseInt(id).toString())) {
      languageIDs = languageIDs.filter(languageID => languageID !== parseInt(id).toString())
    } else {
      languageIDs.push(parseInt(id).toString())
    }

    updateUnsavedFilter({
      teacher_languages: languageIDs.join(',')
    })
  }

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.filters.teacher_speak.title')}</div>
      <div
        className='checkbox-list'
        style={{
          height: expanded ? 290 : 'unset',
          overflowY: expanded ? 'scroll' : 'unset'
        }}
      >
        {languages
          .slice(
            0,
            expanded
              ? (results.most_popular_languages_in_country || []).length
              : (results.most_popular_languages_in_country || []).length === 8
              ? 8
              : 7
          )
          .map(language => (
            <Checkbox
              key={language.id}
              checked={!!selectedLanguages[language.id]}
              onChange={() => toggleTag(language.id)}
            >
              {language.name}
            </Checkbox>
          ))}
      </div>
      <div className='show-hide-button'>
        {(results.most_popular_languages_in_country || []).length > 8 && (
          <div className='subcategories-toggle' onClick={() => setExpanded(!expanded)}>
            <div>
              {expanded
                ? I18n.t('react.search.all_filters.show_languages')
                : I18n.t('react.search.all_filters.hide_languages')}
            </div>
            <div className='filter-modal-arrow'>
              <Arrow stroke='#75a23b' dir={expanded ? 'top' : 'down'} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
